import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../components/landing"
import { soleTraderGuide } from "../content/sole-trader-tax-calculator"
import { guideSeo } from "./guides.$slug"

const PATH = "/sole-trader-tax-calculator"

/** Free sole trader tax calculator (T916); the content is a `Guide`, the URL is top level (copy-products.md). */
export const soleTraderSeo = () => guideSeo(soleTraderGuide, PATH)

export const Route = createFileRoute("/_brand-layout/sole-trader-tax-calculator")({
  head: () => {
    const { meta, links, scripts } = soleTraderSeo()
    return { meta, links, scripts }
  },
  component: () => <GuidePage guide={soleTraderGuide} />,
})
